import { React, useContext } from "react";
import ThemeContext from "../../lib/theme-context";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import dayjs from "dayjs";

const CustomDatePicker = ({ label, value, onChange, format }) => {
  const theme = useContext(ThemeContext);

  return (
    <DatePicker
      sx={{
        "& label": {
          color:
            theme[0] === "dark"
              ? "#FCFCFF !important"
              : "rgba(37,37,37) !important",
        },

        width: "100%",
        height: "50px",

        "& fieldset": {
          // - The <fieldset> inside the Input-root

          borderColor:
            theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  , // - Set the Input border
        },
        "&:hover fieldset": {
          borderColor:
            theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  , // - Set the Input border when parent has :hover
        },
        "&.Mui-focused fieldset": {
          // - Set the Input border when parent is focused
          borderColor:
            theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  ,
        },

        input: {
          color: theme[0] === "dark" ? "#FCFCFF" : "black",
        },
      }}
      slotProps={{
        textField: { size: "small" },
        popper: { 
          placement: "auto",
          sx: {
            zIndex: 99999,
            "& .MuiPaper-root": {
              backgroundColor: theme[0] === "dark" ? "#1e1e1e" : "#ffffff",
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersDay-root": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
              "&:hover": {
                backgroundColor: theme[0] === "dark" ? "rgba(252, 252, 255, 0.1)" : "rgba(0, 0, 0, 0.04)",
              },
            },
            "& .MuiPickersDay-root.Mui-selected": {
              backgroundColor: theme[0] === "dark" ? "#0079cf" : "#1976d2",
            },
            "& .MuiPickersCalendarHeader-label": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersCalendarHeader-labelContainer .MuiSvgIcon-root": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersArrowSwitcher-button": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiDayCalendar-weekDayLabel": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersYear-yearButton": {
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
            },
            "& .MuiPickersYear-yearButton.Mui-selected": {
              backgroundColor: theme[0] === "dark" ? "#0079cf" : "#1976d2",
            },
            "& .MuiDialogActions-root button": {
              color: theme[0] === "dark" ? "#FCFCFF" : "#1976d2",
            },
          },
        },
      }}
      slots={{
        openPickerIcon: () => (
          <CalendarMonthIcon
            sx={{
              color:
                theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  ,
            }}
          />
        ),
      }}
      label={label}
      value={value ? dayjs(new Date(value)) : null}
      onChange={onChange}
      format={format}
    />
  );
};

export default CustomDatePicker;
